import React from "react";
import BrandAdContainer from "web/react/components/brand-ad-container/brand-ad-container";
import { FeedHeader } from "web/react/components/feed-header/feed-header";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import { gettext } from "web/script/modules/django-i18n";
import { RelatedProductsLayoutSerializer } from "web/types/serializers";
import styles from "./related-products-page.module.css";

interface RelatedProductsPageProps {
    data: RelatedProductsLayoutSerializer;
}

const BrandAdWrapper: React.FC<{
    advert: RelatedProductsLayoutSerializer["brand_ad"];
}> = ({ advert }) => {
    if (!advert) {
        return null;
    }

    return (
        <div className={styles.brandAdvert}>
            <BrandAdContainer {...advert} />
        </div>
    );
};

export function RelatedProductsPage({ data }: RelatedProductsPageProps): JSX.Element {
    const onClick = useClickTracker("navigation", "related_products_feed_return");

    return (
        <>
            <FeedHeader
                title={gettext("related_products.main_heading")}
                subtitle={
                    <a className={styles.subtitle} onClick={onClick} href={data.product_link}>
                        {`${data.designer_name} – ${data.product_description}`}
                    </a>
                }
            />

            <BrandAdWrapper advert={data.brand_ad} />
        </>
    );
}
